export default __webpack_public_path__ + "static/media/1-mobile+hor.934dadc9.jpg";